import { cookieService } from './CookieService';
import { ajaxService } from './AjaxService';
import config from '../config';
import ApiCalls from '../pods/auth/api/ApiCalls';

class AuthService {
    public isAuthenticated() {
        const cookie = cookieService.getCookie();
        const scope = cookie ? cookieService.getScope(cookie.accessToken) : null;
        return !!cookie && !!scope;
    }

    public async logout() {
        return new Promise(async (resolve, reject) => {
            try {
                const cookie = cookieService.getCookie();

                await ApiCalls.logout({ payload: { token: cookie?.refreshToken } });
                cookieService.removeCookie();
                localStorage.clear();
                ajaxService.setAuthToken(null);
                window.location.assign(`${config.PRACTITIONERS_APP_URL}`);
                resolve({});
            } catch (err) {
                reject(err);
            }
        });
    }
}

export const authService = new AuthService();
